import { styled } from "@mui/material/styles";
import { Card, Typography, Button, Box, Grid } from "@mui/material";
import { useColors } from "../../../Context/ColorsContext";

export const CustomCard = styled(Card)(({theme}) => ({
  width: '100%',
  borderRadius: 10,
  boxShadow: 'rgb(61 71 82 / 20%) 0px 4px 8px',
  padding: '1rem 1.2rem',
  [theme.breakpoints.down('md')]: {
    height: '100%',
  }
}))

export const Title = styled(Typography)(({theme}) => {
  return {
    color: '#1b1a1b',
    fontWeight: '700',
    fontSize: '20px',
    [theme.breakpoints.down('md')]: {
      fontSize: '18px',
      display: 'flex',
      width: '100%',
    },
  }
})

export const Subtitle = styled(Typography)(({theme}) => {
  return {
    color: '#8a8a8a',
    [theme.breakpoints.down('md')]: {
      fontSize: '0.90rem',
    }
  }
})

export const Description = styled(Typography)(({theme}) => {
  return {
    color: '#464646',
    fontWeight: '700',
    fontSize: '14px',
    [theme.breakpoints.down('md')]: {
      fontSize: '12px'
    },
  }
})

export const ButtonCustom = styled(Button)(({ theme, inverted = false, processButton = false }) => {
  const { colors } = useColors();
  return {
    width: '100%',
    height: 40,
    padding: 8,
    fontSize: 11,
    lineHeight: 1.4,
    background: inverted ? colors.gray : (processButton ? colors.sidebarSelectColor : colors.buttonActionColor),
    color: inverted ? colors.buttonActionColor : colors.white,
    border: processButton ? `1px solid ${colors.sidebarSelectColor}` : `1px solid ${colors.buttonActionColor}`,
    "&:hover": {
      backgroundColor: inverted ? colors.gray : (processButton ? colors.sidebarSelectColor : colors.buttonActionColor),
      opacity: inverted ? 0.8 : 0.9,
      color: inverted ? colors.buttonActionColor : colors.white,
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: '0.55rem',
      height: 30,

    },
    [theme.breakpoints.down('md')]: {
      height: 30
    }
  }
})

export const BoxCustom = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}))

export const Figure = styled('figure')(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '30px',
  width: '30px',
  minWidth: '30px',
  borderRadius: '50%',
  marginLeft: '1.2rem !important',
  padding: '1rem',
}))

export const AreaIcon = styled('span')(() => {
  const { colors } = useColors();
  return {
    background: colors.orange,
    borderRadius: '50%',
    height: '1.2rem',
    width: '1.2rem',
    lineHeight: '1.2rem',
    display: 'inline-block',
    textAlign: 'center',
    color: colors.white,
    fontSize: '0.9rem'
  }
})

export const BoxModal = styled(Box)(() => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
}))

export const ButtonsContainer = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.up('xs')]: {
    marginTop: 2
  },
  [theme.breakpoints.up('xl')]: {
    marginTop: 30
  },
}))


export const ContainerGroupButtons = styled('div')(({ theme }) => {
  return {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    gap: '0.60rem',
    justifyContent: 'flex-end',
  }
})

export const ContainerButtons = styled('div')(() => {
  return {
    minWidth: 'fit-content',
    flexShrink: 0,
  }
})


export const ContainerButtonsStatus = styled('div')(() => {
  return {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
  }
})

export const ContainerStatus = styled('div')(() => {
  return {
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-start',
  }
})

export const ContainerWorkflows = styled('div')(() => {
  return {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'flex-start',
    alignItems: 'center',
  }
})

export const Container = styled('div')(() => {
  return {
    width: 'auto',
  }
})

export const ContainerButtonsDown = styled('div')(({theme}) => {
  return {
    display: 'flex',
    flexDirection: 'row',
    gap: '0.80rem',
    [theme.breakpoints.up('lg')]: {
      flexDirection: 'column',
    }
  }
})

export const ContainerContent = styled('div')(() => {
  return {
    width: '100%',
    height: '100%'
  }
})

export const TitleSection = styled('div')(({theme}) => {
  return {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    columnGap: 12,
    width: "35%",
    [theme.breakpoints.down('md')]: {
      flexWrap: 'nowrap',
      justifyContent: 'space-between',
      width: "100%",
    },
  }
})

export const HeaderContainer = styled('div')(({theme}) => {
  return {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  }
})

export const WorkflowStatusSection = styled('div')(({theme}) => {
  return {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      width: '65%',
      justifyContent: 'flex-end',
    },
  }
})

export const IconContainer = styled('div')(() => {
  return {
    display: 'flex',
    transform: 'scale(0.5)',
    transformOrigin: 'left center',
    marginRight: -15
  }
})
